import React from "react"
import { useInView } from "react-intersection-observer"
import { HeaderOverWrappedContext } from "./HeaderOverWrappedContext"

export default function useHeaderOverWrapped({ threshold = 0.5 }) {
  const { ref, inView } = useInView({
    threshold,
  })
  const [state, setState] = React.useContext(HeaderOverWrappedContext)
  React.useEffect(() => {
    setState(state => ({ ...state, isDisplay: !inView }))
  }, [inView])

  return { ref }
}
